const DJANGO_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]';

export { DJANGO_DATE_FORMAT };
